module.exports = __webpack_public_path__ + "static/desiderata-786d1189c145ab911ae462b73ea8ba72.jpg";